import { Outlet, useRoutes } from 'react-router-dom';

import { useEntrySource } from '@/entities/entrySource';

import { Loader } from '@/shared/ui/Loader';

import { recordingAuthRoutes } from './recordingAuthRoutes';

const RecordingRoutesRoot = () => useRoutes(recordingAuthRoutes);

export const AuthRoutes = () => {
  const state = useEntrySource();

  if (state.status === 'loading') return <Loader />;

  return state.source === 'recording' ? <RecordingRoutesRoot /> : <Outlet />;
};
